import React from 'react'

const Contact_us = () => {
  return (
    <div className="container my-5">
      <div className="card shadow border-0 p-4 text-center">
        <h2 className="text-primary fw-bold mb-4">Contact Us</h2>

        <p className="text-muted mb-4">
          Have questions or need support? We’re here to help you.  
          Reach out to us using the details below.
        </p>

        <div className="d-flex flex-column align-items-center gap-3">
          <div>
            <h5 className="fw-semibold mb-1">Dartex Technology Private Limited</h5>
            <p className="text-muted mb-0">Your trusted logistics and shipping partner</p>
          </div>

          <div className="mt-3">
            <p className="mb-2">
              📧 <strong>Email:</strong>{" "}
              <a href="mailto:support@dartex.in" className="text-decoration-none text-primary">
                support@dartex.com
              </a>
            </p>
            {/* <p className="mb-2">
              📞 <strong>Phone:</strong>{" "}
              <a href="tel:8128857546" className="text-decoration-none text-primary">
                8128857546
              </a>
            </p> */}
            <p className="mb-0">
              🌐 <strong>Website:</strong>{" "}
              <a href="https://www.dartex.in" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-primary">
                www.dartex.in
              </a>
            </p>
          </div>
        </div>

        <hr className="my-4" />

        <p className="text-muted mb-0">
          Our support team typically responds within 24 hours.  
          Thank you for choosing <strong>Dartex</strong>.
        </p>
      </div>
    </div>
  )
}

export default Contact_us
